import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { AlertCircle } from 'lucide-react';

const COUNTRIES = [
  { code: 'NO', name: 'Norway' },
  { code: 'SE', name: 'Sweden' },
  { code: 'DK', name: 'Denmark' },
  { code: 'FI', name: 'Finland' },
  { code: 'DE', name: 'Germany' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'FR', name: 'France' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'BE', name: 'Belgium' },
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
];

export const CustomerDetailsForm = ({ formData, onChange, legalConfirmed, setLegalConfirmed, error }) => (
  <>
    <div className="space-y-4">
      <div>
        <Label htmlFor="fullName" className="text-sm font-semibold">Full Name *</Label>
        <Input
          id="fullName"
          name="fullName"
          data-testid="checkout-fullname"
          value={formData.fullName}
          onChange={onChange}
          placeholder="John Doe"
          className="mt-1.5 rounded-xl h-12"
        />
      </div>

      <div>
        <Label htmlFor="email" className="text-sm font-semibold">Email *</Label>
        <Input
          id="email"
          name="email"
          type="email"
          data-testid="checkout-email"
          value={formData.email}
          onChange={onChange}
          placeholder="john@example.com"
          className="mt-1.5 rounded-xl h-12"
        />
      </div>

      <div>
        <Label htmlFor="phone" className="text-sm font-semibold">Phone Number *</Label>
        <Input
          id="phone"
          name="phone"
          data-testid="checkout-phone"
          value={formData.phone}
          onChange={onChange}
          placeholder="+1 (555) 000-0000"
          className="mt-1.5 rounded-xl h-12"
        />
      </div>

      <div className="space-y-3 pt-2">
        <Label className="text-sm font-semibold">Shipping Address *</Label>

        <Input
          id="streetAddress"
          name="streetAddress"
          data-testid="checkout-street"
          value={formData.streetAddress}
          onChange={onChange}
          placeholder="Street Address"
          className="rounded-xl h-12"
        />

        <Input
          id="streetAddress2"
          name="streetAddress2"
          data-testid="checkout-street2"
          value={formData.streetAddress2}
          onChange={onChange}
          placeholder="Apt, Suite, Floor (optional)"
          className="rounded-xl h-12"
        />

        <div className="grid grid-cols-2 gap-3">
          <Input
            id="cityState"
            name="cityState"
            data-testid="checkout-city-state"
            value={formData.cityState}
            onChange={onChange}
            placeholder="City, State"
            className="rounded-xl h-12"
          />
          <Input
            id="postalCode"
            name="postalCode"
            data-testid="checkout-postal"
            value={formData.postalCode}
            onChange={onChange}
            placeholder="Postal Code"
            className="rounded-xl h-12"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="country" className="text-sm font-medium text-gray-700">Country *</Label>
          <select
            id="country"
            name="country"
            data-testid="checkout-country"
            value={formData.country}
            onChange={onChange}
            className="w-full h-12 px-3 rounded-xl border border-gray-200 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {COUNTRIES.map((c) => (
              <option key={c.code} value={c.code}>{c.name}</option>
            ))}
          </select>
        </div>
      </div>
    </div>

    <div className="flex items-start space-x-3 p-4 bg-blue-50 rounded-xl border border-blue-100">
      <Checkbox
        id="legal"
        data-testid="checkout-legal-checkbox"
        checked={legalConfirmed}
        onCheckedChange={(checked) => setLegalConfirmed(checked)}
        className="mt-0.5"
      />
      <Label htmlFor="legal" className="text-sm text-gray-700 leading-relaxed cursor-pointer">
        I confirm that I own the rights to the content I upload and that it follows the platform guidelines.
      </Label>
    </div>

    {error && (
      <div className="flex items-center gap-2 p-4 bg-red-50 text-red-700 rounded-xl border border-red-100 text-sm" data-testid="checkout-error">
        <AlertCircle className="w-5 h-5 flex-shrink-0" />
        <span>{error}</span>
      </div>
    )}
  </>
);

export default CustomerDetailsForm;
